export const GATEWAY_TYPE_AUTHORIZE_NET = 2;
export const GATEWAY_TYPE_CYBERSOURCE = 7;
export const GATEWAY_TYPE_STRIPE = 14;
export const GATEWAY_TYPE_SQUARE = 33;

/** Gateways that support payment-plan selection in React checkout. */
export const PAYMENT_PLAN_GATEWAY_TYPES = [
  GATEWAY_TYPE_STRIPE,
  GATEWAY_TYPE_SQUARE,
  GATEWAY_TYPE_AUTHORIZE_NET,
];
export const GATEWAY_TYPE_ADYEN = 35;
export const GATEWAY_TYPE_WORLDPAY = 36;
export const GATEWAY_TYPE_PAYPAL = 4;
